import axios from "axios";

export const getJobDivisions = callback => {
  var promise = axios({
    method: "get",
    url: "/api/job_divisions"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
